export default __webpack_public_path__ + "static/media/I35.4f156676.jpg";